/** @jsxImportSource @emotion/react */
import React, { FC, useState } from 'react';
import { Box, CircularProgress, Fade, Grid } from '@mui/material';
import WeekItem from 'pages/Week/components/WeekItem/WeekItem';
import WeekNavigation from 'pages/Week/components/WeekNavigation';
import { useOpenNearestDayOnEntry } from 'pages/Week/hooks/useOpenNearestDayOnEntry';
import { useWeek } from 'pages/Week/hooks/useWeek';

const Week: FC = () => {
  const [date, setDate] = useState(new Date());
  const { week, days } = useWeek(date);
  const isOpeningNearestDay = useOpenNearestDayOnEntry();

  // todo: group up cart context by week
  // const { meals } = useCartContext();
  //
  // const total = useMemo(
  //   () =>
  //     Object.values(meals).reduce((result, meal) => {
  //       if (days.includes(meal.item.menuItemDate)) {
  //         return result + meal.quantity * meal.item.price;
  //       } else {
  //         return result;
  //       }
  //     }, 0),
  //   [meals],
  // );

  if (isOpeningNearestDay) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Fade in>
      <Box>
        <WeekNavigation date={date} setDate={setDate} />

        <Grid container direction="column" spacing={2} paddingBottom={6}>
          {days.map((day) => (
            <Grid item key={day}>
              <WeekItem week={week} dayDate={day} />
            </Grid>
          ))}
        </Grid>

        {/*todo: uncomment */}
        {/*<Button*/}
        {/*  variant="contained"*/}
        {/*  css={css`*/}
        {/*    position: fixed;*/}
        {/*    width: 100%;*/}
        {/*    left: 0;*/}
        {/*    bottom: 0;*/}
        {/*  `}*/}
        {/*>*/}
        {/*  {t(TXT_WEEK_TOTAL, { total, currency: t(TXT_UAH) })}*/}
        {/*</Button>*/}
      </Box>
    </Fade>
  );
};

export default Week;
